var _rect, _path, _path2, _path3, _path4, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    role: "img",
    "aria-label": "Get it on Google Play",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    rx: 7,
    fill: "currentColor",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5 L8 20 L17.5 14.75 Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20 L8 30.5 L17.5 25.25 Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5 L24 20 L17.5 14.75 Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30.5 L24 20 L17.5 25.25 Z",
    fill: "#FBBC05"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 13,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, sans-serif",
    fontSize: 8.5,
    fill: "currentColor",
    letterSpacing: 0.3
  }, "GET IT ON")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 29,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, sans-serif",
    fontSize: 17,
    fontWeight: 600,
    fill: "currentColor",
    letterSpacing: -0.3
  }, "Google Play")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGoogleplay);
export default __webpack_public_path__ + "static/media/badge-googleplay.f4e9da760f38e3424f9148fac89d5385.svg";
export { ForwardRef as ReactComponent };